import { render, staticRenderFns } from "./ItemPreview.vue?vue&type=template&id=5f3445c4&scoped=true&"
import script from "./ItemPreview.vue?vue&type=script&lang=js&"
export * from "./ItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./ItemPreview.vue?vue&type=style&index=0&id=5f3445c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3445c4",
  null
  
)

export default component.exports